import LeasesHeaderNav from '../components/LeasesHeaderNav';
import { ErrorPage } from '../components/Widgets/ErrorPage';
import { getErrorPageTextProps } from '../utils/getErrorPageTextProps';

export default function LeasesNotFound() {
  return (
    <>
      <LeasesHeaderNav />
      <ErrorPage errorMessage="Page not found" {...getErrorPageTextProps()} />
    </>
  );
}
